import { lazy, FC, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils';
import { WithChildren } from '../../_metronic/helpers';
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper';
import SwitchProfile from '../pages/switch-profile/SwitchProfile';
import AmandemenForm from '../pages/amandemen/components/AmandemenForm';

const PrivateRoutes = () => {
	const capelId = localStorage.getItem('capelId');
	const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
	// const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
	// const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
	const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
	// const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'));
	// const UsersPage = lazy(
	// 	() => import('../modules/apps/user-management/UsersPage')
	// );
	const CustomerProfile = lazy(
		() => import('../pages/customer-profile/CustomerProfile')
	);
	const Usage = lazy(() => import('../pages/usage/Usage'));
	const Invoice = lazy(
		() => import('../pages/customer-profile/components/Invoice')
	);
	const Promotions = lazy(() => import('../pages/promotions/Promotions'));
	const CustomerSupport = lazy(
		() => import('../pages/customer-support/CustomerSupport')
	);
	const PurchaseHistory = lazy(
		() => import('../pages/purchase-history/PurchaseHistory')
	);
	const PromoDetail = lazy(
		() => import('../pages/promotions/components/DetailPromotions')
	);
	const Amandemen = lazy(() => import('../pages/amandemen/Amandemen'));
	const NewAmandemen = lazy(
		() => import('../pages/amandemen/components/NewAmandemen')
	);
	const Profile = lazy(() => import('../pages/profile/Profile'));
	const SupportFrom = lazy(
		() => import('../pages/customer-support/components/ServiceForm')
	);
	const AmendmentDetail = lazy(
		() => import('../pages/amandemen/components/AmandemenDetail')
	);
	const GasSubscription = lazy(
		() => import('../pages/gas-subscription/GasSubscription')
	);
	const SubscriptionDetail = lazy(
		() => import('../pages/gas-subscription/components/SubscriptionDetail')
	);

	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route path="auth/*" element={<Navigate to="/dashboard" />} />
				<Route path="dashboard" element={<DashboardWrapper />} />
				<Route path="switch-profile" element={<SwitchProfile />} />
				<Route
					path="customer-profile/*"
					element={
						<SuspensedView>
							<CustomerProfile />
						</SuspensedView>
					}
				/>
				<Route
					path="usage/*"
					element={
						<SuspensedView>
							<Usage />
						</SuspensedView>
					}
				/>
				<Route
					path="invoice/:invoice_num"
					element={
						<SuspensedView>
							<Invoice />
						</SuspensedView>
					}
				/>
				<Route
					path="promotions"
					element={
						<SuspensedView>
							<Promotions />
						</SuspensedView>
					}
				/>
				<Route
					path="customer-support/:page"
					element={
						<SuspensedView>
							<CustomerSupport />
						</SuspensedView>
					}
				/>

				<Route
					path="purchase-history/:page"
					element={
						<SuspensedView>
							<PurchaseHistory />
						</SuspensedView>
					}
				/>
				<Route
					path="amendment/:page"
					element={
						<SuspensedView>
							<Amandemen />
						</SuspensedView>
					}
				/>
				<Route
					path="draft-amendment/:amandemen_id/*"
					element={
						<SuspensedView>
							<NewAmandemen isEdit={true} />
						</SuspensedView>
					}
				/>
				<Route
					path="detail-amendment/:id/*"
					element={
						<SuspensedView>
							<AmendmentDetail />
						</SuspensedView>
					}
				/>
				<Route
					path="setting"
					element={
						<SuspensedView>
							<Profile />
						</SuspensedView>
					}
				/>
				<Route
					path="new-amendment"
					element={
						<SuspensedView>
							<NewAmandemen isEdit={false}/>
						</SuspensedView>
					}
				/>
				{capelId != 'null' && capelId != null && (
					<>
						<Route
							path="gas-subscription/:page"
							element={
								<SuspensedView>
									<GasSubscription />
								</SuspensedView>
							}
						/>
						<Route
							path="subscription/:kid/:fid"
							element={
								<SuspensedView>
									<SubscriptionDetail />
								</SuspensedView>
							}
						/>
					</>
				)}
				<Route
					path="customer-support/support-form"
					element={
						<SuspensedView>
							<SupportFrom />
						</SuspensedView>
					}
				/>
				<Route
					path="promotions/:promo_id"
					element={
						<SuspensedView>
							<PromoDetail />
						</SuspensedView>
					}
				/>
				<Route path="builder" element={<BuilderPageWrapper />} />
				<Route path="menu-test" element={<MenuTestPage />} />
				{/* <Route
					path="crafted/pages/profile/*"
					element={
						<SuspensedView>
							<ProfilePage />
						</SuspensedView>
					}
				/> */}
				{/* <Route
					path="crafted/pages/wizards/*"
					element={
						<SuspensedView>
							<WizardsPage />
						</SuspensedView>
					}
				/> */}
				<Route
					path="crafted/widgets/*"
					element={
						<SuspensedView>
							<WidgetsPage />
						</SuspensedView>
					}
				/>
				{/* <Route
					path="crafted/account/*"
					element={
						<SuspensedView>
							<AccountPage />
						</SuspensedView>
					}
				/> */}
				{/* <Route
					path="apps/chat/*"
					element={
						<SuspensedView>
							<ChatPage />
						</SuspensedView>
					}
				/>
				<Route
					path="apps/user-management/*"
					element={
						<SuspensedView>
							<UsersPage />
						</SuspensedView>
					}
				/> */}

				<Route path="*" element={<Navigate to="/error/404" />} />
			</Route>
		</Routes>
	);
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
	const baseColor = getCSSVariableValue('--bs-primary');
	TopBarProgress.config({
		barColors: {
			'0': baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	});
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
